import {
  Component,
  HostBinding,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import {
  InternalStatusHistory,
  WasteProfile,
} from '@digital-platform/waste-profiles/domain';

@Component({
  selector: 'digital-platform-internal-status-history-table',
  templateUrl: './internal-status-history-table.component.html',
  styleUrls: ['./internal-status-history-table.component.scss'],
})
export class InternalStatusHistoryTableComponent implements OnChanges {
  @HostBinding() class = 'digital-platform-waste-profile-table';
  @Input() wasteProfile: WasteProfile;
  @Input() filter: string;

  public dateFormat = 'LLL.dd.yy';

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  selectedRow: any;

  public displayedColumns = [
    'date',
    'type',
    'userName',
    'internalStatus',
    'status',
  ];

  public dataSource = new MatTableDataSource<InternalStatusHistory>();

  constructor() {
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (data, sortHeaderId: string) =>
      this.getPropertyByPath(data, sortHeaderId);
  }
  getPropertyByPath(obj: any, pathString: string) {
    return pathString.split('.').reduce((o, i) => o[i], obj);
  }

  ngOnChanges(): void {
    if (this.wasteProfile) {
      this.dataSource.data = this.wasteProfile.log.sort(
        (a, b) => b.version - a.version
      );
      this.dataSource.sort = this.sort;

      if (this.filter) {
        this.dataSource.filter = this.filter;
      }
    }
  }
}
